export const LABELS = {
  APPLICATION_FILE: "申請ファイル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  ERROR_TITLE: "提出ファイルエラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  APPLICATION_CONFIRM: "\r\n・申請ファイル\r\nファイル名：{0}",
  REGISTRATION_COUNT: "{0}件登録します。",
};

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
};
